// extracted by mini-css-extract-plugin
module.exports = {"solutionsCard":"solutions-card_solutionsCard__CqN_p","solutionsCardImageContainer":"solutions-card_solutionsCardImageContainer__Ez31L"};